import { render, staticRenderFns } from "./chart2.vue?vue&type=template&id=6133d0f5&scoped=true&"
import script from "./chart2.vue?vue&type=script&lang=js&"
export * from "./chart2.vue?vue&type=script&lang=js&"
import style0 from "./chart2.vue?vue&type=style&index=0&id=6133d0f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133d0f5",
  null
  
)

export default component.exports